import { defineStore } from 'pinia'
import { computed, inject, ref } from 'vue'
import axios from 'axios'
import { BACKEND_BASEURL } from '@/config/config'
import { useSnackbarStore } from '@es-bill/es-bill-common-components'
import { useI18n } from 'vue-i18n'

export const useMeteringPointMembershipsStore = defineStore('meteringPointMembershipsStore', () => {
  const { t } = useI18n()
  const $log = inject('log')
  const snackbarStore = useSnackbarStore()

  const meteringPointMemberships = ref([])
  const meteringPointMembershipsLoading = ref(false)

  const allMeteringPointMemberships = computed(() => meteringPointMemberships.value)
  const allMeteringPointMembershipsLoading = computed(() => meteringPointMembershipsLoading.value)

  async function fetchMeteringPointMemberships() {
    meteringPointMembershipsLoading.value = true;
    meteringPointMemberships.value = [];

    try {
      const response = await axios.get(BACKEND_BASEURL + 'metadata/memberships')
      meteringPointMemberships.value = response.data.map((mpm) => {
        return {
          ...mpm,
          mpmObjectId: mpm._id,
          dateStart: new Date(mpm.dateStart),
          dateEnd: mpm.dateEnd ? new Date(mpm.dateEnd) : mpm.dateEnd,
        }
      })
      return response.data;
    } catch (error) {
      $log?.warn(error);
      snackbarStore.showSnackbar(t('connectionProblem'), '', 'Warning', 10000, []);
      throw error;
    } finally {
      meteringPointMembershipsLoading.value = false;
    }
  }

  function getMeteringPointMemberships(mpmObjectId) {
    const results = meteringPointMemberships.value.filter((mpm) => mpm._id === mpmObjectId)
    if (results.length > 1) $log?.warn('too many memberships for given ID, selecting first')
    if (results.length >= 1) return results[0]
    return null
  }

  function getMeteringPointMembershipsForClient(client) {
    if (client?.clientCode?.length)
      return meteringPointMemberships.value.filter((mpm) => mpm.clientCode === client.clientCode)
    return []
  }

  return {
    // state
    allMeteringPointMemberships,
    allMeteringPointMembershipsLoading,

    // getters
    getMeteringPointMemberships,
    getMeteringPointMembershipsForClient,

    // actions
    fetchMeteringPointMemberships,
  }
})


